export default "__VITE_ASSET__6adcc182__"